<template>
  <div style="width: 100%">
    <!-- Dados Pessoais e Profissionais -->
    <v-row align="center">
      <!-- Foto -->
      <v-col
        class="d-flex flex-column align-center mb-md-10"
        cols="12"
        md="6"
      >
        <v-avatar size="220px">
          <img
            :src="imagemPreview"
            alt="Imagem do Perfil"
          >
        </v-avatar>
      </v-col>
      <!-- Dados -->
      <v-col
        cols="12"
        md="4"
      >
        <!-- Nome -->
        <h1 class="title primary--text pb-md-6">
          {{ usuario.nome }}
        </h1>

        <!-- Siape -->
        <v-row class="my-md-3">
          <span>
            <v-icon class="primary--text">pin</v-icon>
            {{ usuario.siape }}
          </span>
        </v-row>
        <!-- E-mail -->
        <v-row class="my-md-3">
          <span>
            <v-icon class="primary--text">alternate_email</v-icon>
            {{ usuario.email }}
          </span>
        </v-row>
        <!-- Cargo -->
        <v-row class="my-md-3">
          <span>
            <v-icon class="primary--text">engineering</v-icon>
            {{ usuario.cargo }}
          </span>
        </v-row>
        <!-- Unidade de Esxercício -->
        <v-row class="my-md-3">
          <span>
            <v-icon class="primary--text">account_balance</v-icon>
            {{ usuario.unidade.nome }}
          </span>
        </v-row>
        <!-- Unidade Superior -->
        <v-row
          v-if="usuario.unidade.unidadePai"
          class="my-md-3"
        >
          <span>
            <v-icon class="primary--text">account_balance</v-icon>
            {{ usuario.unidade.unidadePai.nome }}
          </span>
        </v-row>
        <!-- Função -->
        <v-row
          v-if="usuario.funcao"
          class="my-md-3"
        >
          <span>
            <v-icon class="primary--text">badge</v-icon>
            {{ usuario.funcao }}
          </span>
        </v-row>
        <!-- Contato -->
        <v-row
          v-if="usuario.contato"
          class="my-md-3"
        >
          <span>
            <v-icon class="primary--text">phone</v-icon>
            {{ usuario.contato }}
          </span>
        </v-row>
        <!-- Deficiência -->
        <v-row
          v-if="perfil.deficiente"
          class="my-md-3"
        >
          <span class="primary--text">
            <v-icon class="primary--text">accessible</v-icon>
            <b>Condição de deficiência:&nbsp;</b>
          </span>
          <span>{{
            !perfil.deficiencias.length > 0 ? "Sim" : deficiencias
          }}</span>
        </v-row>
        <!-- Observção Deficiência -->
        <v-row
          v-if="
            perfil.observacoesDeficiencias != null &&
              perfil.observacoesDeficiencias != ''
          "
          class="my-md-3"
        >
          <span class="primary--text">
            <v-icon class="primary--text">settings_accessibility</v-icon>
            <b>Tendo em vista a sua condição, como seria um ambiente de trabalho
              adaptado às suas necessidades?&nbsp;</b>
          </span>
          <span>{{ perfil.observacoesDeficiencias }}</span>
        </v-row>
      </v-col>
    </v-row>

    <!-- Timeline -->
    <v-row class="align-center">
      <v-col cols="2" />
      <v-col cols="8">
        <v-timeline
          align-top
          clipped
          dense
        >
          <!-- Formação -->
          <v-timeline-item
            class="white--text primary--text align-center"
            fill-dot
            icon="school"
            large
          >
            <h2 class="title primary--text text--darken-1 text-no-wrap">
              FORMAÇÃO
            </h2>
          </v-timeline-item>
          <v-timeline-item hide-dot>
            <h3 class="subtitle-1 primary--text ml-n4">
              FORMAÇÃO ACADÊMICA
            </h3>
          </v-timeline-item>

          <!-- Escolaridades -->
          <v-timeline-item
            v-for="escolaridade in escolaridades"
            :key="'escolaridade_' + escolaridade.id"
            class="align-top"
            small
          >
            <v-row class="mt-n3">
              <v-col cols="6">
                {{ getCursoInstituicao(escolaridade) }}
                <ul>
                  <li>
                    <b class="primary--text">Nível:</b>
                    {{ escolaridade.nivelEscolaridade.descricao }}
                  </li>
                  <li>
                    <b class="primary--text">Situação:</b>
                    {{ escolaridade.status.descricao }}
                  </li>
                </ul>
              </v-col>
              <v-col
                class="text-right"
                cols="3"
              >
                {{ formatDate(escolaridade.inicio) }} -
                {{ escolaridade.termino ? formatDate(escolaridade.termino) : "até hoje" }}
              </v-col>
            </v-row>
          </v-timeline-item>

          <!-- Áreas de Pesquisa -->
          <v-timeline-item
            v-if="areasPesquisa.length > 0"
            small
          >
            <v-row class="mt-n3">
              <v-col cols="6">
                <span class="primary--text">Áreas de Pesquisa</span>
                <ul
                  v-for="area in areasPesquisa"
                  :key="'areaPesquisa_' + area.id"
                >
                  <li>
                    {{ area.nome }}
                  </li>
                </ul>
              </v-col>
            </v-row>
          </v-timeline-item>

          <!-- Formção Complementar -->
          <v-timeline-item
            class="mb-2"
            hide-dot
          >
            <h3 class="subtitle-1 primary--text ml-n4">
              FORMAÇÃO COMPLEMENTAR
            </h3>
          </v-timeline-item>

          <!-- Cursos de Capacitação -->
          <v-timeline-item
            v-if="cursosCapacitacao.length > 0"
            class="mb-2"
            hide-dot
          >
            <h4 class="subtitle-2 primary--text">
              CURSOS DE CAPACITAÇÃO (Total: {{ totalHorasCursoCapacitacao }}H)
            </h4>
          </v-timeline-item>
          <v-timeline-item
            v-for="curso in cursosCapacitacao"
            :key="'cursoCapacitacao_' + curso.id"
            class="align-top"
            small
          >
            <v-row class="mt-n3">
              <v-col cols="6">
                {{ curso.nome }} - {{ curso.instituicao }}
                <ul>
                  <li>
                    <b class="primary--text">Área:</b> {{ curso.area.nome }}
                  </li>
                  <li>
                    <b class="primary--text">Carga Horária:</b>
                    {{ curso.cargaHoraria }}h
                  </li>
                </ul>
              </v-col>
              <v-col
                class="text-right"
                cols="3"
              >
                {{ formatDate(curso.inicio) }} - {{ formatDate(curso.termino) }}
              </v-col>
            </v-row>
          </v-timeline-item>

          <!-- Instrutor de Capacitação -->
          <div
            v-if="
              perfil.instrutorCapacitacao &&
                cursosInstrutorCapacitacao.length > 0
            "
          >
            <v-timeline-item
              class="mb-2 mt-2"
              hide-dot
            >
              <h4 class="subtitle-2 primary--text">
                INSTRUTOR DE CAPACITAÇÃO
              </h4>
            </v-timeline-item>

            <v-timeline-item
              v-for="instrutor in cursosInstrutorCapacitacao"
              :key="'instrutorCapacitacao_' + instrutor.id"
              class="align-top"
              small
            >
              <v-row class="mt-n3">
                <v-col cols="6">
                  {{ instrutor.nome }}
                </v-col>
              </v-row>
            </v-timeline-item>
          </div>

          <!-- Idiomas -->
          <div v-if="idiomas.length > 0">
            <v-timeline-item
              class="mb-2 mt-2"
              hide-dot
            >
              <h4 class="subtitle-2 primary--text">
                IDIOMAS
              </h4>
            </v-timeline-item>

            <v-timeline-item
              v-for="idioma in idiomas"
              :key="'idioma_' + idioma.id"
              class="align-top"
              small
            >
              <v-row class="mt-n3">
                <v-col cols="6">
                  {{ idioma.nomeIdioma }}
                  <ul>
                    <li>
                      <b class="primary--text">Compreensão:</b>
                      {{ idioma.compreensao.descricao }}
                    </li>
                    <li>
                      <b class="primary--text">Escrita:</b>
                      {{ idioma.escrita.descricao }}
                    </li>
                    <li>
                      <b class="primary--text">Fala:</b>
                      {{ idioma.fala.descricao }}
                    </li>
                    <li>
                      <b class="primary--text">Leitura:</b>
                      {{ idioma.leitura.descricao }}
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-timeline-item>
          </div>

          <!-- Atuação Profissional -->
          <v-timeline-item
            class="white--text primary--text align-center"
            fill-dot
            icon="handyman"
            large
          >
            <h2 class="title primary--text text--darken-1 text-no-wrap">
              ATUAÇÃO PROFISSIONAL
            </h2>
          </v-timeline-item>

          <!-- Experiências Profissionais -->
          <v-timeline-item hide-dot>
            <h3 class="subtitle-1 primary--text ml-n4">
              EXPERIÊNCIAS PROFISSIONAIS (Total:
              {{ getDescricaoTempo(totalHorasExperienciaProfissional) }})
            </h3>
          </v-timeline-item>
          <v-timeline-item
            v-for="ep in experienciasProfissionais"
            :key="'experienciaProfissional_' + ep.id"
            class="align-top"
            small
          >
            <v-row class="mt-n3">
              <v-col cols="6">
                {{ ep.nomeCargo }} - {{ ep.instituicao }}
                <ul>
                  <li>
                    <b class="primary--text">Setor:</b> {{ ep.nomeSetor }}
                  </li>
                  <li>
                    <b class="primary--text">Vínculo:</b> {{ ep.nomeVinculo }}
                  </li>
                  <li>
                    <b class="primary--text">Função:</b> {{ ep.nomeFuncao }}
                  </li>
                  <li>
                    <b class="primary--text">Nível de Gratificação:</b>
                    {{ ep.nomeNivelGratificacao }}
                  </li>
                  <li>
                    <b class="primary--text">Situação:</b>
                    {{ ep.status.descricao }}
                  </li>
                  <li>
                    <b class="primary--text">Tempo de Experiência:</b>
                    {{ getDescricaoTempo(getCargaHoraria(ep)) }}
                  </li>
                </ul>
              </v-col>
              <v-col
                class="text-right"
                cols="3"
              >
                {{ formatDate(ep.inicio) }} -
                {{
                  ep.status && ep.status.id === "ATUAL"
                    ? "até hoje"
                    : formatDate(ep.termino)
                }}
              </v-col>
            </v-row>
          </v-timeline-item>

          <!-- Áreas de Atuacao -->
          <v-timeline-item
            v-if="areasProfissional.length > 0"
            small
          >
            <v-row class="mt-n3">
              <v-col cols="6">
                <span class="primary--text">Áreas de Atuação</span>
                <ul
                  v-for="area in areasProfissional"
                  :key="'areaProfissional_' + area.id"
                >
                  <li>
                    {{ area.nome }}
                  </li>
                </ul>
              </v-col>
            </v-row>
          </v-timeline-item>

          <!-- Atividades de Interesse -->
          <v-timeline-item
            class="white--text primary--text align-center"
            fill-dot
            icon="favorite"
            large
          >
            <h2 class="title primary--text text--darken-1 text-no-wrap">
              ATIVIDADES DE INTERESSE
            </h2>
          </v-timeline-item>

          <!-- Áreas de Cultura e Arte -->
          <v-timeline-item hide-dot>
            <h3 class="subtitle-1 primary--text ml-n4">
              ÁREAS DE CULTURA E ARTE
            </h3>
          </v-timeline-item>

          <v-timeline-item
            v-for="area in areasCultura"
            :key="'areaCultura_' + area.id"
            small
          >
            <v-row class="mt-n3">
              <v-col cols="6">
                {{ area.nome }}
              </v-col>
            </v-row>
          </v-timeline-item>

          <!-- Instrutor de Cultura e Arte -->
          <div
            v-if="perfil.instrutorCultura && cursosInstrutorCultura.length > 0"
          >
            <v-timeline-item hide-dot>
              <h3 class="subtitle-1 primary--text ml-n4">
                INSTRUTOR DE CULTURA E ARTE
              </h3>
            </v-timeline-item>

            <v-timeline-item
              v-for="instrutor in cursosInstrutorCultura"
              :key="'instrutorCultura_' + instrutor.id"
              small
            >
              <v-row class="mt-n3">
                <v-col cols="6">
                  {{ instrutor.nome }}
                </v-col>
              </v-row>
            </v-timeline-item>
          </div>

          <!-- Áreas de Esporte -->
          <v-timeline-item hide-dot>
            <h3 class="subtitle-1 primary--text ml-n4">
              ÁREAS DE ESPORTE
            </h3>
          </v-timeline-item>
          <v-timeline-item
            v-for="area in areasEsporte"
            :key="'areaEsporte_' + area.id"
            small
          >
            <v-row class="mt-n3">
              <v-col cols="6">
                {{ area.nome }}
              </v-col>
            </v-row>
          </v-timeline-item>

          <!-- Instrutor de Esporte -->
          <div
            v-if="perfil.instrutorEsporte && cursosInstrutorEsporte.length > 0"
          >
            <v-timeline-item hide-dot>
              <h3 class="subtitle-1 primary--text ml-n4">
                INSTRUTOR DE ESPORTE
              </h3>
            </v-timeline-item>

            <v-timeline-item
              v-for="instrutor in cursosInstrutorEsporte"
              :key="'instrutorEsporte_' + instrutor.id"
              small
            >
              <v-row class="mt-n3">
                <v-col cols="6">
                  {{ instrutor.nome }}
                </v-col>
              </v-row>
            </v-timeline-item>
          </div>
        </v-timeline>
      </v-col>
    </v-row>

    <!-- Preferências de Trabalho -->
    <v-row align="center">
      <v-col cols="2" />
      <v-col cols="8">
        <h2 class="title primary--text text--darken-1 text-no-wrap mt-0 ml-2">
          PREFERÊNCIAS DE TRABALHO
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="2" />
      <v-col cols="8">
        <ol style="padding-left: 37px">
          <v-row
            v-for="pp in perfil.perfilPreferencias"
            :key="pp.preferencia.id"
            class="my-2"
          >
            <li>
              <b class="secondary--text">{{ pp.preferencia.nome }}:</b>
              {{ itemPreferenciaDescricao(pp.itemPreferencia) }}
            </li>
          </v-row>
        </ol>
      </v-col>
    </v-row>

    <!-- Relatório PDF -->
    <v-row
      class="justify-end mb-1"
    >
      <v-tooltip
        max-width="400"
        top
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="success"
            @click="getRelatorio()"
            v-on="on"
          >
            <v-icon>get_app</v-icon>
            BAIXAR PDF
          </v-btn>
        </template>
        <span>Clique para baixar o relatório dos dados em formato PDF.</span>
      </v-tooltip>
    </v-row>
  </div>
</template>

<script>
import DEFAULT_IMAGEM_PERFIL from '@/modules/var/defaultImagemPerfil';
import { generatePDF } from '@/modules/relatorioPDF';
import { formatNomeArquivo } from '@/modules/texto';
import Data from '@/modules/data';

export default {
  name: 'Perfil',

  props: {
    usuario: {
      type: Object,
      required: true,
    },
    perfilProprio: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      imagemPreview: '',
    };
  },

  computed: {
    perfil() {
      return this.usuario.perfil;
    },
    deficiencias() {
      return this.perfil.deficiencias
        .slice()
        .sort((a, b) => a.nome.localeCompare(b.nome))
        .map((d) => d.nome)
        .join(', ');
    },
    escolaridades() {
      return this.perfil.escolaridades.slice().sort((a, b) => a.inicio.localeCompare(b.inicio));
    },
    areasPesquisa() {
      return this.perfil.areasPesquisa.slice().sort((a, b) => a.nome.localeCompare(b.nome));
    },
    totalHorasCursoCapacitacao() {
      return this.perfil.cursosCapacitacao.reduce((acumulator, c) => acumulator + c.cargaHoraria, 0);
    },
    cursosCapacitacao() {
      return this.perfil.cursosCapacitacao.slice().sort((a, b) => a.inicio.localeCompare(b.inicio));
    },
    cursosInstrutorCapacitacao() {
      return this.perfil.cursosInstrutor
        .filter((c) => c.tipo === 'CAPACITACAO')
        .slice()
        .sort((a, b) => a.nome.localeCompare(b.nome));
    },
    idiomas() {
      return this.perfil.idiomas.slice().sort((a, b) => a.nomeIdioma.localeCompare(b.nomeIdioma));
    },
    experienciasProfissionais() {
      return this.perfil.experienciasProfissionais.slice().sort((a, b) => a.inicio.localeCompare(b.inicio));
    },
    areasProfissional() {
      return this.perfil.areasProfissional.slice().sort((a, b) => a.nome.localeCompare(b.nome));
    },
    areasCultura() {
      return this.perfil.areasCultura.slice().sort((a, b) => a.nome.localeCompare(b.nome));
    },
    cursosInstrutorCultura() {
      return this.perfil.cursosInstrutor
        .filter((c) => c.tipo === 'CULTURA')
        .slice()
        .sort((a, b) => a.nome.localeCompare(b.nome));
    },
    areasEsporte() {
      return this.perfil.areasEsporte.slice().sort((a, b) => a.nome.localeCompare(b.nome));
    },
    cursosInstrutorEsporte() {
      return this.perfil.cursosInstrutor
        .filter((c) => c.tipo === 'ESPORTE')
        .slice()
        .sort((a, b) => a.nome.localeCompare(b.nome));
    },
    totalHorasExperienciaProfissional() {
      const months = new Set();
      for (const e of this.perfil.experienciasProfissionais) {
        for (const m of this.getMonths(e)) {
          months.add(m);
        }
      }
      return months.size;
    },
  },

  created() {
    this.imagemPreview = DEFAULT_IMAGEM_PERFIL;
  },

  methods: {
    onFileChange(e) {
      if (e == null) {
        this.imagemPreview = DEFAULT_IMAGEM_PERFIL;
        return;
      }
      this.createImage(e);
    },
    formatDate(date) {
      return Data.format(date, 'MM/YYYY');
    },
    getCursoInstituicao(escolaridade) {
      if (escolaridade.curso) {
        if (escolaridade.curso.isOutro && escolaridade.nomeCursoOutro) {
          return `${escolaridade.nomeCursoOutro} - ${escolaridade.instituicao}`;
        }
        return `${escolaridade.curso.nome} - ${escolaridade.instituicao}`;
      }
      if (escolaridade.residenciaEm) {
        return `${escolaridade.residenciaEm} - ${escolaridade.instituicao}`;
      }
      return escolaridade.instituicao;
    },
    getCargaHoraria(item) {
      return this.getMonths(item).length;
    },
    getMonths(item) {
      const inicio = Data.create(item.inicio);
      const termino = Data.create(item.status.id === 'ATUAL' ? Data.get('YYYY-MM-DD') : item.termino);
      const currentMonth = inicio.clone();
      const months = [];

      while (currentMonth.isSameOrBefore(termino)) {
        months.push(currentMonth.format('MM/YYYY'));
        currentMonth.add(1, 'months');
      }
      return months;
    },
    getDescricaoTempo(meses) {
      if (meses < 12) {
        let descricao = '';

        if (meses === 0) {
          descricao += '0';
        } else if (meses === 1) {
          descricao += `${meses} mês`;
        } else {
          descricao += `${meses} meses`;
        }

        return descricao;
      }
      const anos = parseInt(meses / 12, 10);
      meses -= anos * 12;
      let descricao = anos;

      if (anos === 1) {
        descricao += ' ano';
      } else {
        descricao += ' anos';
      }

      if (meses === 0) {
        descricao += '';
      } else if (meses === 1) {
        descricao += ` e  ${meses} mês`;
      } else {
        descricao += ` e  ${meses} meses`;
      }

      return descricao;
    },
    itemPreferenciaDescricao(itemPreferencia) {
      if (itemPreferencia && itemPreferencia.id) {
        if (this.perfilProprio) {
          return itemPreferencia.descricao;
        }
        return itemPreferencia.descricaoAlternativa;
      }
      return 'Sem resposta';
    },
    getRelatorio() {
      const documento = {
        nome: `perfil-servidor-${formatNomeArquivo(`${this.usuario.nome}`)}`,
        cabecalho: {
          titulo: 'Perfil do Servidor',
          subtitulo: this.usuario.nome,
          itens: [
            `Unidade: ${this.usuario.unidade.nome} (${this.usuario.unidade.sigla})`,
            `Matricula: ${this.usuario.siape}`,
            `E-mail: ${this.usuario.email}`,
            `Cargo: ${this.usuario.cargo}`,
            `${this.usuario.contato ? `Contato: ${this.usuario.contato}` : ''}`,
          ],
        },
        blocos: [
          {
            titulo: 'FORMAÇÃO',
            subtitulo: 'FORMAÇÃO ACADÊMICA',
            itens: [
              {
                tipo: 'texto',
                valor: 'ESCOLARIDADES:',
              },
              {
                tipo: 'tabela',
                valor: {
                  colunas: [
                    'ESCOLARIDADE',
                    'NÍVEL',
                    'SITUAÇÃO',
                    'PERÍODO',
                  ],
                  linhas: this.usuario.perfil.escolaridades.map((e) => ([
                    this.getCursoInstituicao(e),
                    e.nivelEscolaridade.descricao,
                    e.status ? e.status.descricao : '',
                    `${Data.format(e.inicio)} - ${e.termino ? Data.format(e.termino) : 'até hoje'}`,
                  ])),
                },
              },
              {
                tipo: 'texto',
                valor: `ÁREAS DE PESQUISA: ${this.usuario.perfil.areasPesquisa.map((a) => a.nome).join(', ')}`,
              },
            ],
          },
          {
            titulo: 'FORMAÇÃO',
            subtitulo: 'FORMAÇÃO COMPLEMENTAR',
            itens: [
              {
                tipo: 'texto',
                valor: `CURSOS DE CAPACITAÇÃO: (Total: ${this.totalHorasCursoCapacitacao}H)`,
              },
              {
                tipo: 'tabela',
                valor: {
                  colunas: [
                    'CURSO',
                    'ÁREA',
                    'CARGA HORÁRIA',
                    'PERÍODO',
                  ],
                  linhas: this.usuario.perfil.cursosCapacitacao.map((c) => ([
                    c.nome,
                    c.area.nome,
                    c.cargaHoraria,
                    `${Data.format(c.inicio)} - ${c.termino ? Data.format(c.termino) : 'até hoje'}`,
                  ])),
                },
              },
              {
                tipo: 'texto',
                valor: 'IDIOMAS:',
              },
              {
                tipo: 'tabela',
                valor: {
                  colunas: [
                    'IDIOMA',
                    'COMPREENSÃO',
                    'ESCRITA',
                    'FALA',
                    'LEITURA',
                  ],
                  linhas: this.usuario.perfil.idiomas.map((i) => ([
                    i.idioma.nome,
                    i.compreensao.descricao,
                    i.escrita.descricao,
                    i.fala.descricao,
                    i.leitura.descricao,
                  ])),
                },
              },
            ],
          },
          {
            titulo: 'ATUAÇÃO PROFISSIONAL',
            itens: [
              {
                tipo: 'texto',
                valor: `EXPERIÊNCIAS PROFISSIONAIS (Total: ${
                  this.getDescricaoTempo(this.totalHorasExperienciaProfissional)
                })`,
              },
              {
                tipo: 'tabela',
                valor: {
                  colunas: [
                    'EXPERIÊNCIA\nPROFISSIONAL',
                    'VÍNCULO',
                    'FUNÇÃO',
                    'NÍVEL\nDE\nGRATIFI-\nCAÇÃO',
                    'SITUAÇÃO',
                    'PERÍODO',
                    'TEMPO\nDE\nEXPERI\n-ÊNCIA',
                  ],
                  linhas: this.usuario.perfil.experienciasProfissionais.map((e) => ([
                    `${e.nomeCargo} - ${e.instituicao}`,
                    e.nomeVinculo,
                    e.nomeFuncao,
                    e.nomeNivelGratificacao,
                    e.status ? e.status.descricao : '',
                    `${Data.format(e.inicio)} - ${
                      e.status && e.status.id === 'ATUAL' ? 'até hoje' : Data.format(e.termino)
                    }`,
                    this.getDescricaoTempo(this.getCargaHoraria(e)),
                  ])),
                },
              },
              {
                tipo: 'texto',
                valor: `ÁREAS DE ATUAÇÃO PROFISSIONAL: ${
                  this.usuario.perfil.areasProfissional.map((a) => a.nome).join(', ')
                }`,
              },
            ],
          },
          {
            titulo: 'ATIVIDADES DE INTERESSE',
            itens: [
              {
                tipo: 'texto',
                valor: `ÁREAS DE CULTURA E ARTE: ${
                  this.usuario.perfil.areasCultura.map((a) => a.nome).join(', ')
                }`,
              },
              {
                tipo: 'texto',
                valor: `ÁREAS DE ESPORTE: ${
                  this.usuario.perfil.areasEsporte.map((a) => a.nome).join(', ')
                }`,
              },
            ],
          },
          {
            titulo: 'PREFERÊNCIAS DE TRABALHO',
            itens: [
              {
                tipo: 'texto',
                valor: this.usuario.perfil.perfilPreferencias.map((p) => this.getPreferencia(p)).join('\n\n'),
              },
            ],
          },
        ],
      };
      generatePDF(documento);
    },
    getPreferencia(p) {
      return `${p.preferencia.ordem}. ${p.preferencia.nome.toUpperCase()}: ${
        p.itemPreferencia ? p.itemPreferencia.descricao : ''}`;
    },
  },
};
</script>

<style scoped>
h1.title {
  font-size: 2rem !important;
}
</style>
